/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Chart_Position1Inputs */

const id_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posisi`)
};

const ms_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedudukan`)
};

const da_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const de_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const en_us2_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const es_es2_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición`)
};

const es_mx2_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición`)
};

const fil_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posisyon`)
};

const fr_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const it_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione`)
};

const hu_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozíció`)
};

const nl_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positie`)
};

const no_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posisjon`)
};

const pl_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozycja`)
};

const pt_br2_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição`)
};

const pt_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição`)
};

const ro_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poziție`)
};

const fi_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sijoitus`)
};

const sv_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const vi_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí`)
};

const tr_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozisyon`)
};

const cs_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozice`)
};

const bg_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция`)
};

const ru_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция`)
};

const uk_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиція`)
};

const ar_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المركز`)
};

const hi_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थान`)
};

const th_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตำแหน่ง`)
};

const ja_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順位`)
};

const zh_cn2_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名`)
};

const zh_hant1_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名`)
};

const ko_components_performancetable_chart_position1 = /** @type {(inputs: Components_Performancetable_Chart_Position1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`순위`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Components_Performancetable_Chart_Position1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_chart_position1 = /** @type {((inputs?: Components_Performancetable_Chart_Position1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Chart_Position1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_chart_position1(inputs)
	if (locale === "ms") return ms_components_performancetable_chart_position1(inputs)
	if (locale === "da") return da_components_performancetable_chart_position1(inputs)
	if (locale === "de") return de_components_performancetable_chart_position1(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_chart_position1(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_chart_position1(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_chart_position1(inputs)
	if (locale === "fil") return fil_components_performancetable_chart_position1(inputs)
	if (locale === "fr") return fr_components_performancetable_chart_position1(inputs)
	if (locale === "it") return it_components_performancetable_chart_position1(inputs)
	if (locale === "hu") return hu_components_performancetable_chart_position1(inputs)
	if (locale === "nl") return nl_components_performancetable_chart_position1(inputs)
	if (locale === "no") return no_components_performancetable_chart_position1(inputs)
	if (locale === "pl") return pl_components_performancetable_chart_position1(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_chart_position1(inputs)
	if (locale === "pt") return pt_components_performancetable_chart_position1(inputs)
	if (locale === "ro") return ro_components_performancetable_chart_position1(inputs)
	if (locale === "fi") return fi_components_performancetable_chart_position1(inputs)
	if (locale === "sv") return sv_components_performancetable_chart_position1(inputs)
	if (locale === "vi") return vi_components_performancetable_chart_position1(inputs)
	if (locale === "tr") return tr_components_performancetable_chart_position1(inputs)
	if (locale === "cs") return cs_components_performancetable_chart_position1(inputs)
	if (locale === "bg") return bg_components_performancetable_chart_position1(inputs)
	if (locale === "ru") return ru_components_performancetable_chart_position1(inputs)
	if (locale === "uk") return uk_components_performancetable_chart_position1(inputs)
	if (locale === "ar") return ar_components_performancetable_chart_position1(inputs)
	if (locale === "hi") return hi_components_performancetable_chart_position1(inputs)
	if (locale === "th") return th_components_performancetable_chart_position1(inputs)
	if (locale === "ja") return ja_components_performancetable_chart_position1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_chart_position1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_chart_position1(inputs)
	return ko_components_performancetable_chart_position1(inputs)
});
export { components_performancetable_chart_position1 as "components.performanceTable.chart.position" }